import { useInternet } from "../../../../hooks/useInternet.js";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { SimpleField } from "../../../../components/fields/simpleField.jsx";
import { HOST } from "../../../../hooks/constants.js";
import { useResource } from "../../../../hooks/useResource.js";
import { Button } from "../../../../components/button.jsx";

export function Step1({ setStep }) {
  let internet = useInternet();
  let session = useSelector((state) => state.session);
  let { control, handleSubmit, reset, formState, watch, setValue } = useForm({
    resolver: zodResolver(
      zod.object({
        logo: zod.number().nullish(),
        companyName: zod.string().nullish(),
      })
    ),
    defaultValues: session.account,
  });

  let accountService = useResource("accounts");
  let save = (d) => {
    return accountService.edit("me", d).then(() => setStep(2));
  };

  const onDrop = useCallback(async (files) => {
    let data = new FormData();
    for (let file of files) data.append("files", file);
    internet.post("/uploads", data).then(async (res) => {
      let uploads = await res.json();
      setValue("logo", uploads[0].id, { shouldDirty: true });
    });
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });

  return (
    <div className={"flex flex-col gap-3 text-center"}>
      <div className={"font-bold"}>
        Give us a few information about your company
      </div>
      <div>
        We will use this data to provide accurate accounting information, help
        you generate documents, ...
      </div>

      <form
        onSubmit={handleSubmit(save)}
        className={"flex flex-col gap-3 bg-white p-3 rounded"}
      >
        <SimpleField
          name={"companyName"}
          label="company_name"
          control={control}
        />

        <div
          {...getRootProps()}
          className={
            "border border-gray-400 p-3 border-dashed bg-white hover:bg-blue-50 cursor-pointer flex flex-col gap-3 rounded"
          }
        >
          <input {...getInputProps()} />
          <p>Upload your company logo</p>

          {watch("logo") && (
            <div style={{ width: 200 }}>
              <img
                src={`${HOST}/uploads/${watch("logo")}/download?token=${
                  window.localStorage.token
                }`}
              />
            </div>
          )}
        </div>

        <Button formState={formState} type={"submit"}>
          next
        </Button>
      </form>
    </div>
  );
}
